/**
 * Lazy images carry no reserved height until they land, so the document
 * grows under positions ScrollTrigger has already measured and the scroll
 * effects fire at the wrong place. Re-measure as the images arrive — except
 * in the strips, whose frames reserve their box (aspect-ratio): those images
 * land while the strip slides by, and a refresh mid-slide only stutters.
 *
 * @module motion/media-refresh
 */

import { $$ } from '../lib/dom.js';
import { ScrollTrigger } from '../lib/gsap.js';

export function refreshOnMediaLoad() {
    const pending = $$('img').filter((image) => !image.complete && !image.closest('[data-strip-track]'));

    if (!pending.length) {
        return;
    }

    let timer = 0;

    const refresh = () => {
        window.clearTimeout(timer);
        timer = window.setTimeout(() => ScrollTrigger.refresh(), 150);
    };

    pending.forEach((image) => {
        image.addEventListener('load', refresh, { once: true });
        image.addEventListener('error', refresh, { once: true });
    });
}
